export default "__VITE_ASSET__CgnabPvM__"